import WeeklyAnalysis from './WeeklyAnalysis';

export default WeeklyAnalysis;
